import React from 'react'
import Header from '../../../common/header/Header'

function Bembeke() {
  return (
    <>
    <Header/>
    <div className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0">
    <div className="absolute inset-0 -z-10 overflow-hidden">
      <svg
        className="absolute left-[max(50%,25rem)] top-0 h-[64rem] w-[128rem] -translate-x-1/2 stroke-gray-200 [mask-image:radial-gradient(64rem_64rem_at_top,white,transparent)]"
        aria-hidden="true"
      >
        <defs>
          <pattern
            id="e813992c-7d03-4cc4-a2bd-151760b470a0"
            width={200}
            height={200}
            x="50%"
            y={-1}
            patternUnits="userSpaceOnUse"
          >
            <path d="M100 200V.5M.5 .5H200" fill="none" />
          </pattern>
        </defs>
        <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
          <path
            d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
            strokeWidth={0}
          />
        </svg>
        <rect width="100%" height="100%" strokeWidth={0} fill="url(#e813992c-7d03-4cc4-a2bd-151760b470a0)" />
      </svg>
    </div>
    <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
      <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
        <div className="lg:pr-4">
          <div className="lg:max-w-lg">
            <p className="text-base font-semibold leading-7 text-green-600">Farm Radio Trust</p>
            <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Farm Radio Trust Partners with Radio Bembeke FM</h1>
            <p className="mt-6 text-xl leading-8 text-gray-700">
            Farm Radio Trust (FRT) has partnered with Radio Bembeke FM to produce and broadcast a new radio programme titled "Tipindule ndi Ulimi wa Mtedza ndi Mbatatesi," targeting farmers in Dedza District. 
            </p>
            <p className="mt-6 text-xl leading-8 text-gray-700">
            The initiative is part of FRT's Communication for Scaling good agricultural practices (GAP) Project funded by the International Fund for Agricultural Development (IFAD) through the Transforming Agriculture through Diversification and Entrepreneurship (TRADE) Programme. The broader programme is being implemented across 11 districts.
            </p>
          </div>
        </div>
      </div>
      <div className="-ml-16 -mt-8 -mr-28 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
        <img
          className="w-[111%]  rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
          src="/image/blog/bembeke.jpeg"
          alt="Bembeke Story"
        />
      </div>

      <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
        <div className="lg:pr-4">
          <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
            <p>
              The Communication for Scale Project seeks to address key challenges affecting smallholder farmers, including limited access to agricultural extension and advisory services, low productivity across value chains, and the underutilization of ICTs in extension delivery. To bridge these gaps, FRT is leveraging digital solutions to expand access to timely and practical farming information, working closely with Assistant Agricultural Extension Development Officers (AAEDOs) in the target districts.
            </p>
            <p className="mt-6">
              In Dedza, however, some farmers reported difficulties accessing existing radio programs due to poor signal coverage in certain areas. The collaboration with Radio Bembeke FM is a direct response to this concern, ensuring that more farmers can access relevant agricultural information through a station with stronger local reach.
            </p>
            <p className="mt-6">
              As part of the rollout, Radio Bembeke FM producer McDonald Kachiwala recorded content for the first episode during the Dedza District Field Day held on 9 April 2026 at Khwakhwa in Traditional Authority Kaphuka, as well as during a session with Kanyama Cooperative members on 15 April 2026. The inaugural program is scheduled to air on Monday, 20 April 2026 at 3:30 PM, with a repeat broadcast on Saturday, 25 April 2026. The program will henceforth be aired on Mondays and Saturdays at the same scheduled times.
            </p>
            <p className="mt-6">
              Through this initiative, FRT continues to strengthen farmer access to knowledge, using radio as a powerful tool to promote improved agricultural practices and enhance productivity.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
    </>
  )
}

export default Bembeke
